module.exports = __webpack_public_path__ + "img/Cti12PpmResMi0003A.37c86862.jpg";